import React, { useContext } from 'react'
import { ContentHeader } from '../../../layout/Content'
import NPOSAccountHeaderStyle from './css/NPOSAccountHeaderStyle'
import { nposAccountControllerContext } from './NPOSAccountController'

function NPOSAccountHeader() {
  const nposAccountController = useContext(nposAccountControllerContext)
  const [activeTab, setActiveTab] = nposAccountController.activeTab
  const { app } = nposAccountController

  return (
    <ContentHeader title="Settings | Account">
      <div className='tab-button-container'>
        <button
          onClick={() => { setActiveTab('users-accounts') }}
          className={(activeTab === 'users-accounts') ? 'tab-button active-tab' : 'tab-button'}>
          User's Accounts
        </button>
        <button
          onClick={() => { setActiveTab('admin-config') }}
          style={{display: (app.client.signed_in === 'admin') ? 'block' : 'none'}}
          className={(activeTab === 'admin-config') ? 'tab-button active-tab' : 'tab-button'}>
          Admin Config
        </button>
        <button
          onClick={() => { setActiveTab('users-scheduler') }}
          style={{display: (app.client.signed_in === 'admin') ? 'block' : 'none'}}
          className={(activeTab === 'users-scheduler') ? 'tab-button active-tab' : 'tab-button'}>
          User's Scheduler
        </button>
      </div>
      <NPOSAccountHeaderStyle />
    </ContentHeader>
  )
}

export default React.memo(NPOSAccountHeader)